function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import React from 'react';
import { SelectFacet } from '../Facets/SelectFacet';
import { ListFacet } from '../Facets/ListFacet';
import { ChipFacet } from '../Facets/ChipFacet';
var FacetList = function FacetList() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var FacetsMapper = [SelectFacet, ChipFacet, ListFacet].concat(_toConsumableArray(components)).reduce(function (sum, component) {
    sum[component.DISPLAY] = component;
    return sum;
  }, {});
  return function (_ref) {
    var data = _ref.data,
      loading = _ref.loading;
    return /*#__PURE__*/React.createElement("div", {
      className: "SearchFacets"
    }, data && data.facets && data.facets.map(function (facet) {
      var Facet = FacetsMapper[facet.display];
      if (!Facet) {
        throw new Error(facet.display + ' not available');
      }
      return /*#__PURE__*/React.createElement(Facet, {
        facet: facet,
        loading: loading
      });
    }));
  };
};
var SearchFacets = function SearchFacets(_ref2) {
  var data = _ref2.data,
    loading = _ref2.loading,
    facets = _ref2.facets;
  var Facets = FacetList(facets);
  if (!data) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "SearchFacets"
  }, /*#__PURE__*/React.createElement(Facets, {
    data: data.results,
    loading: loading
  }));
};
SearchFacets.defaultProps = {
  data: null,
  loading: false,
  facets: []
};
export default SearchFacets;